<template>
  <div class="side-view" :class="{'side-view-simpe': simpleMode}">
    <div class="graph-view-text" v-show="!simpleMode">
      <div class="graph-view_title">
        <div class="side-img"></div>
        <span>{{$t(title)}}</span>
      </div>
    </div>
    <div class="graph-view_describe" v-show="!simpleMode">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor1) }}</span></div>
      <div class="graph-view_screen"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor2) }} </span></div>
    </div>
    <div class='graph-view_checkbox' v-show="!simpleMode">
      <div class='Projector_checkbox'>
        <el-checkbox v-model='projectorCheckedSideData'><span>{{$t('T_CHANGE_PJ_POS')}}</span></el-checkbox>
      </div>
    </div>
    <Cv
      id="sideView"
      :w="depthInit"
      :h="heightInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrOffsetLines="arrOffsetLines"
      :arrRectLines="arrRectLines"
      :arrLightingArea="arrLightingArea"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrRectHorSecLines="arrRectHorSecLines"
      :arrCurveRect="arrCurveRect"
      :arrRectArea="arrRectArea"
      @setArrHelpLine="setArrHelpLine"
      @moveCenter="moveCenter"
      ref="sideView"
    >
    </Cv>

    <div type="primary" :class="{ 'middle-btn':this.throw_distance_checked === false,'middle-btndis':this.throw_distance_checked === true }" :style="{ right: centerPosition.x + 'px', top: centerPosition.y + 'px'}"    size="small" @click="toCenter()">{{ $t('T_CENTER') }}</div>

    <div class="graph-slider-block" :class="{'hidden':this.vAngleFlag === false}">
      <div class="slider-title-v">{{ $t(sliderTitle) }}</div>
      <div class="slider-item">{{ $t(sliderMsg1) }}</div>
      <el-slider
        v-model="vAngleData"
        :max="sliderMax"
        :min="sliderMin"
        :step="0.1"
        vertical
        :height="sliderHeight"
        :disabled="!vAngleFlagData"
        :show-tooltip= false>
      </el-slider>
      <div class="slider-item">{{ $t(sliderMsg2) }}</div>
      <div class="graph-view_slider-input">
        <el-input v-model.number="vAngleDataSilder" class="side_input" :class="{'red_out': (!indAngleSwitch && isVOut) || (indAngleSwitch && !isOnCornerAreas)}" :disabled="!vAngleFlagData" @input="testDigitalNegative($event, 'vAngleData')" @blur="testDigitalNegativeBlur">
          <template slot="suffix"><span style="line-height: 26px;">{{sliderAppend}}</span></template>
        </el-input>
      </div>
    </div>
    <div class="angle-msg" v-if="isVOutTypeOne">{{$t('T_CHANGE_SETTING_MSG')}}</div>
    <div class="angle-msg" v-if="isVOutTypeTwo">{{$t('T_CAUSE_MALFUNCTION_OR_ACCIDENT_MSG')}}</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'sideView',
  data () {
    return {
      title: 'T_SIDE_VIEW',
      strColor1: 'T_AVAILABLE_RANGE',
      strColor2: 'T_MSG_OUT_WALL',
      sliderTitle: 'T_ANGLE',
      sliderMsg1: 'T_UP',
      sliderMsg2: 'T_DOWN',
      sliderMax: 90,
      sliderMin: -90,
      sliderAppend: '°',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: {},
      arrDashLines: [],
      arrDashRemainLines: [],
      arrOffsetLines: [],
      arrRectLines: [],
      arrLightingArea: [],
      arrCatchArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      arrRectHorSecLines: [],
      arrRectArea: [],
      arrCurveRect: [],
      depthInit: 0,
      heightInit: 0,

      helpDisMin: 10,
      helpDisMax: 18,
      helpNeDis: 40,
      helpTextDis: 20,
      helpBesideDis: 10,
      sliderHeight: '0px',
      vAngleDataSilder: 0,
      vAngleTypeOneArr: ['EB-Z', 'EB-G6', 'EB-G7', 'CB-Z', 'CB-G6', 'CB-G7', 'Pro Z', 'Pro G6', 'Pro G7'],
      centerPosition: {
        x: 0,
        y: 0
      }
    }
  },

  props: {
    simpleMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'vAngle',
      'houseInfo',
      'vAngleFlag',
      'hAngleFlag',
      'drawData',
      'lenghProInit',
      'widthProInit',
      'projectorCheckedSide',
      'offset',
      'dashData',
      'curveCenter',
      'curveRadius',
      'curveCentralAngle',
      'curveDepth',
      'curveShape',
      'dashFlag',
      'curveDirection',
      'limitData',
      'isOnCornerAreas',
      'indAngleSwitch',
      'keyStoneVertical',
      'selectedModelData',
      'searchTabActive',
      'throwDistanceChecked'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      }
    },
    vAngleFlagData () {
      return this.vAngleFlag
    },
    vAngleData: {
      get () {
        return this.vAngle
      },
      set (value) {
        this.$store.commit('SET_VANGLE', value)
      }
    },
    projectorCheckedSideData: {
      get () {
        return this.projectorCheckedSide
      },
      set (value) {
        this.$store.commit('SET_PROJECTORCHECKEDSIDE', value)
      }
    },
    isVTypeThree () {
      return this.selectedModelData.lightType === 'Laser Diode'
    },
    isVTypeOne () {
      let value = false
      if (this.selectedModelData.lightType !== 'Lamp') {
        return value
      }
      for (let i = 0; i < this.vAngleTypeOneArr.length; i++) {
        if (this.selectedModelData.name.indexOf(this.vAngleTypeOneArr[i]) !== -1) {
          value = true
          break
        }
      }
      return value
    },
    isVTypeTwo () {
      return !this.isVTypeThree && !this.isVTypeOne
    },
    isVOutTypeOne () {
      return this.vAngleFlagData && this.isVTypeOne && !this.keyStoneVertical
    },
    isVOutTypeTwo () {
      return this.vAngleFlagData && this.isVTypeTwo && Math.abs(this.vAngleData) > 30
    },
    isVOutTypeThree () {
      return this.vAngleFlagData && this.isVTypeThree && !this.keyStoneVertical
    },
    isVOut () {
      let value = this.isVOutTypeOne || this.isVOutTypeTwo || this.isVOutTypeThree
      this.$store.commit('SET_ISVANGLEOUT', value)

      return value
    }
  },
  created () {
    this.depthInit = this.houseInfo.roomD
    this.heightInit = this.houseInfo.roomH
  },
  mounted () {
    this.child = this.$refs.sideView
    this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.vAngleDataSilder = this.vAngleData
    this.initCanvasData()
    this.$nextTick(function () {
      // this.child.drawCv()
    })
    this.unWatchDrawData = this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})

    this.unWatchHouseInfo = this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.depthInit = this.houseInfo.roomD
      this.heightInit = this.houseInfo.roomH
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, {deep: true})

    this.unWatchSearchTabActive = this.$watch('searchTabActive', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})
  },
  destroyed () {
    this.unWatchDrawData()
    this.unWatchHouseInfo()
    this.unWatchSearchTabActive()
  },
  methods: {
    ...mapMutations([
      'SET_VANGLE', 'SET_ISVANGLEOUT', 'SET_VLENSSHIFT', 'SET_HLENSSHIFT', 'PJX',
      'PJZ'
    ]),
    toCenter () {
      if (!this.throw_distance_checked) {
        this.SET_HLENSSHIFT(0)
        this.PJZ(this.houseInfo.roomH / 2)
      }
    },
    initCanvasData () {
      if (!this.drawData) {
        return
      }
      this.arrRectPoints = this.drawData[0]
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      this.arrLightingArea = []
      // 镜头水平倾斜时出现的第二条屏幕延伸线数组
      this.arrRectHorSecLines = []
      // 虚线
      this.arrDashLines = []
      // 虚线
      this.arrDashRemainLines = []
      // Offset
      this.arrOffsetLines = []
      // 投影仪可拖动区域
      this.avlRect = null
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 斜边投影区域
      this.arrCatchArea = []
      // 曲面弧
      this.arrCurveRect = []
      // 四边形
      this.arrRectArea = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setArrOffsetLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrRectLines()
      this.setArrLightingArea()
      this.setArrCurveRect()
      // this.setArrHelpLine(0)
      // this.setArrHelpText()
    },

    setArrCurveRect () {
      if (Math.abs(this.curveDepth) < this.limitData) {
        return
      }
      if (this.curveShape === '0') {
        // 先清掉之前的左边的竖线
        if (this.curveDirection === '1' && this.searchTabActive === 'CurvedSurface') {
          var clearLine = this.$draw.toLine(
            0,
            0,
            0,
            this.houseInfo.roomH,
            '#EAEAEA',
            2
          )
          this.arrRectLines.push(clearLine)
        }

        // 画圆弧
        var curAng = this.curveDirection === '0' ? 180 : 0
        var curveArea = this.$draw.toCurveArea(
          this.curveCenter,
          this.houseInfo.roomH / 2,
          this.curveRadius,
          curAng,
          this.curveCentralAngle,
          this.$constant.roomLineColor,
          this.curveDirection === '0' ? '' : this.$constant.canvasBgColor,
          2
        )
        this.arrCurveRect.push(curveArea)
      }
      //  else if (this.curveDirection === '1') {
      //   let rect0 = this.$draw.toRectArea(
      //     -this.curveDepth,
      //     0,
      //     this.curveDepth,
      //     this.houseInfo.roomH,
      //     this.$constant.roomLineColor,
      //     this.$constant.roomFillColor,
      //     2
      //   )
      //   this.arrRectArea.push(rect0)
      // }
    },

    setPjRect () {
      var x = this.$commonViewJs.getAy()
      var y = this.$commonViewJs.getAz()
      var width = this.lenghProInit
      var height = this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.houseInfo.roomD,
        this.houseInfo.roomH
      )
    },
    setAvlRect () {
      if (this.$commonViewJs.isAvlExist()) {
        var k = this.$draw.toPoint(
          this.$commonViewJs.getKy(),
          this.$commonViewJs.getKz()
        )
        var l = this.$draw.toPoint(
          this.$commonViewJs.getLy(),
          this.$commonViewJs.getLz()
        )
        this.avlRect = this.$draw.toRect(
          k.x,
          k.y,
          l.x - k.x,
          l.y - k.y
        )
      }
    },
    setArrRectLines () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[0]
      for (let i = 0; i < data0.length; i++) {
        var rectLines = this.$draw.toLine(
          this.drawData[0][i].y,
          this.drawData[0][i].z,
          this.$commonViewJs.getAy(),
          this.graph.pjZ,
          this.$constant.rectLineColor,
          0.8
        )
        this.arrRectLines.push(rectLines)
      }
    },
    setArrLightingArea () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[2]
      let LightingPoints1 = []
      for (let j = 0; j < data0.length; j++) {
        LightingPoints1.push(this.$draw.toPoint(data0[j].y, data0[j].z))
      }
      LightingPoints1.push(this.$draw.toPoint(this.$commonViewJs.getAy(), this.graph.pjZ))
      this.arrLightingArea.push(LightingPoints1)
    },
    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].y, this.drawData[i][j].z))
        }
      }
    },
    setArrDashLines () {
      var dashLine0 = this.$draw.toLine(
        0,
        this.$commonViewJs.getGz(),
        this.$commonViewJs.getEy(),
        this.$commonViewJs.getEz()
      )
      this.arrDashLines.push(dashLine0)
      var dashLine1 = this.$draw.toLine(
        this.$commonViewJs.getKy(),
        0,
        this.$commonViewJs.getKy(),
        this.$commonViewJs.getFz()
      )
      this.arrDashLines.push(dashLine1)
      if (this.$commonViewJs.isAvlExist()) {
        var dashLine2 = this.$draw.toLine(
          this.$commonViewJs.getLy(),
          0,
          this.$commonViewJs.getLy(),
          this.$commonViewJs.getFz()
        )
        this.arrDashLines.push(dashLine2)
      }
    },
    setArrDashRemainLines () {
      // 屏幕锁定在点击倾斜角度时，获取的屏幕虚线
      var dashLine1
      if (this.dashFlag) {
        for (let i = 1; i < this.dashData.length; i++) {
          for (let j = 1; j < this.dashData[i].length; j++) {
            dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].y, this.dashData[i][j - 1].z, this.dashData[i][j].y, this.dashData[i][j].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
          if (i === this.dashData.length - 1) {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[1][0].y, this.dashData[1][0].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[i + 1][0].y, this.dashData[i + 1][0].z, '#000000', 2)
            this.arrDashRemainLines.push(dashLine1)
          }
        }
      }
    },
    setArrOffsetLines () {
      if (this.$commonViewJs.isOffsetExist()) {
        var dashLine = this.$draw.toLine(
          this.offset,
          0,
          this.offset,
          this.$commonViewJs.getFz(),
          this.$constant.dashLineColor,
          1.2
        )
        this.arrOffsetLines.push(dashLine)
      }
    },
    setArrHelpLine (proportion) {
      // 上辅助线
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)
      var helpLine0 = this.$draw.toLine(
        0,
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      if (this.$commonViewJs.isOffsetExist()) {
        helpLine0 = this.$draw.toLine(
          this.offset,
          0 - this.helpDisMin,
          this.offset,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine0)
      }
      var helpLine1 = this.$draw.toLine(
        this.$commonViewJs.getAy(),
        0 - this.helpDisMin,
        this.$commonViewJs.getAy(),
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine1)
      var helpLine2 = this.$draw.toLine(
        0,
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.houseInfo.roomD > this.$commonViewJs.getAy() ? this.houseInfo.roomD : this.$commonViewJs.getAy(),
        0 - (this.helpDisMax + this.helpDisMin) / 2,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine2)

      var helpLine3 = this.$draw.toLine(
        this.houseInfo.roomD,
        0 - this.helpDisMin,
        this.houseInfo.roomD,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine3)
      // 右辅助线
      var helpLine5 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        0,
        this.houseInfo.roomD + this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjZ > 0) this.arrHelpLines.push(helpLine5)
      var helpLine6 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        this.$commonViewJs.getAz(),
        this.houseInfo.roomD + this.helpDisMax,
        this.$commonViewJs.getAz(),
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine6)
      var helpLine7 = this.$draw.toLine(
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        0,
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine7)
      var helpLine12 = this.$draw.toLine(
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        this.$commonViewJs.getAz(),
        this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjZ < 0) this.arrHelpLines.push(helpLine12)
      var helpLine8 = this.$draw.toLine(
        this.houseInfo.roomD + this.helpDisMin,
        this.houseInfo.roomH,
        this.houseInfo.roomD + this.helpDisMax,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine8)
      // 曲面スクリーン機能の改善
      if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface') {
        // 右辅助线房间的高度
        var neDis = 180
        var helpLine15 = this.$draw.toLine(
          this.houseInfo.roomD + this.helpDisMin + neDis,
          0,
          this.houseInfo.roomD + this.helpDisMax + neDis,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine15)
        var helpLine16 = this.$draw.toLine(
          this.houseInfo.roomD + this.helpDisMin + neDis,
          this.houseInfo.roomH,
          this.houseInfo.roomD + this.helpDisMax + neDis,
          this.houseInfo.roomH,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine16)
        var helpLine17 = this.$draw.toLine(
          this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
          0,
          this.houseInfo.roomD + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
          this.houseInfo.roomH,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine17)
      }

      // 下辅助线
      if (this.$commonViewJs.isAvlExist()) {
        var helpLine9 = this.$draw.toLine(
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + this.helpDisMin,
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine9)
        var helpLine10 = this.$draw.toLine(
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + this.helpDisMin,
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine10)
        var helpLine11 = this.$draw.toLine(
          this.$commonViewJs.getKy(),
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.$commonViewJs.getLy(),
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine11)
      }
      // 左辅助线
      // let curDep = this.curveDirection === '0' ? -this.curveDepth : (this.curveDirection === '1' ? this.curveDepth : 0)
      let curDep = this.curveDepth ? this.curveDepth : 0
      if (this.curveDepth > 0 && this.searchTabActive === 'CurvedSurface') {
        // 添加上辅助线
        var helpLineLeftc = this.$draw.toLine(
          0 + curDep,
          0 - this.helpDisMin,
          0 + curDep,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeftc)
        helpLineLeftc = this.$draw.toLine(
          0 + curDep,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeftc)
        var textName0 = this.$commonJs.changeUnitDraw(this.curveDepth, this.graph.unit, false)
        var helpText0 = this.$draw.toText(
          curDep / 2,
          0 - this.helpTextDis,
          textName0
        )
        this.arrHelpText.push(helpText0)
      }
      // curDep = this.curveDirection === '0' ? -this.curveDepth : 0
      var helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        0,
        0 - this.helpDisMax,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjZ > 0) this.arrHelpLines.push(helpLineLeft)
      let mp = this.getPointCurMaxAndMin()
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        mp.minP.z,
        0 - this.helpDisMax,
        mp.minP.z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        mp.maxP.z,
        0 - this.helpDisMax,
        mp.maxP.z,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - this.helpDisMin,
        this.houseInfo.roomH,
        0 - this.helpDisMax,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        this.houseInfo.roomH,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLineLeft)
      helpLineLeft = this.$draw.toLine(
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        mp.minP.z,
        0 - (this.helpDisMin + this.helpDisMax) / 2,
        0,
        this.$constant.helpLineColor,
        0.8
      )
      if (this.graph.pjZ < 0) this.arrHelpLines.push(helpLineLeft)

      this.setArrHelpText(proportion, mp)
      // this.setMiddleHelpLine(proportion)
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点(为曲面)
    getPointCurMaxAndMin () {
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (this.drawData[i][j].z > initDMax.z) {
            initDMax = this.drawData[i][j]
          }
          if (this.drawData[i][j].z < initDMin.z) {
            initDMin = this.drawData[i][j]
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    // 获取z轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的z为this.houseInfo.roomW的点
    getPointMaxAndMin () {
      let maxFlag = false
      let minFlag = false
      let outFlag = true
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 0; i < this.drawData[0].length; i++) {
        if (this.drawData[0][i].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
          outFlag = false
        }
      }
      if (outFlag) {
        return {
          maxP: {x: 0, y: 0, z: this.houseInfo.roomH},
          minP: {x: 0, y: 0, z: 0}
        }
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (Math.abs(this.drawData[i][j].z - this.houseInfo.roomH) < this.limitData && !maxFlag) {
            maxFlag = true
            initDMax = this.drawData[i][j]
          } else if (this.drawData[i][j].z < this.limitData && !minFlag) {
            minFlag = true
            initDMin = this.drawData[i][j]
          } else if (this.drawData[i][j].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
            if (this.drawData[i][j].z > initDMax.z && !maxFlag) {
              initDMax = this.drawData[i][j]
            }
            if (this.drawData[i][j].z < initDMin.z && !minFlag) {
              initDMin = this.drawData[i][j]
            }
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    setArrHelpText (value, mp) {
      let bs = 10 * value
      let lis = 7 * value
      let curDis = this.curveDepth && this.searchTabActive === 'CurvedSurface' ? this.curveDepth : 0
      let curDisName = this.$commonJs.changeUnitDraw(this.graph.pjY - (this.curveDirection === '0' ? curDis : 0), this.graph.unit, false)
      // 上
      if (this.$commonViewJs.isOffsetExist()) {
        var textName0 = this.$commonJs.changeUnitDraw(this.offset, this.graph.unit, false)
        var helpText0 = this.$draw.toText(
          this.offset / 2,
          0 - this.helpTextDis,
          textName0
        )
        this.arrHelpText.push(helpText0)
      }
      textName0 = this.$commonJs.changeUnitDraw(this.graph.pjY, this.graph.unit, false)
      helpText0 = this.$draw.toText(
        curDis + (this.graph.pjY - (this.curveDirection === '0' ? curDis : 0)) / 2 + this.offset,
        0 - this.helpTextDis,
        curDisName
      )
      this.arrHelpText.push(helpText0)

      var textName1 = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomD - this.$commonViewJs.getAy(), this.graph.unit, false
      )
      var helpText1 = this.$draw.toText(
        (this.houseInfo.roomD + this.$commonViewJs.getAy()) / 2,
        0 - this.helpTextDis,
        textName1
      )
      this.arrHelpText.push(helpText1)

      var textName2 = this.$commonJs.changeUnitDraw(this.$commonViewJs.getAz(), this.graph.unit, false)
      var helpText2 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis,
        this.$commonViewJs.getAz() / 2 + lis,
        textName2
      )
      this.arrHelpText.push(helpText2)

      var textName3 = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomH - this.$commonViewJs.getAz(), this.graph.unit, false
      )
      var helpText3 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis,
        (this.$commonViewJs.getAz() + this.houseInfo.roomH) / 2 + lis,
        textName3
      )
      this.arrHelpText.push(helpText3)
      // ==================右辅助文字(房间的高度)===============

      // 曲面スクリーン機能の改善
      if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface') {
        var neDis = 150
        var textName10 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH, this.graph.unit, false)
        var helpText10 = this.$draw.toText(
          this.houseInfo.roomD + this.helpTextDis + neDis + this.helpBesideDis,
          this.houseInfo.roomH / 2 + lis,
          textName10
        )
        this.arrHelpText.push(helpText10)
      }

      if (this.$commonViewJs.isAvlExist()) {
        var textName4 = this.$commonJs.changeUnitDraw(
          this.$commonViewJs.getLy() - this.$commonViewJs.getKy(), this.graph.unit, false
        )
        var helpText4 = this.$draw.toText(
          (this.$commonViewJs.getLy() + this.$commonViewJs.getKy()) / 2,
          this.houseInfo.roomH + this.helpTextDis + bs,
          textName4
        )
        this.arrHelpText.push(helpText4)
      }
      var textName5 = '(' + this.unitLabel + ')'
      var helpText5 = this.$draw.toText(
        this.houseInfo.roomD + this.helpTextDis + this.helpBesideDis,
        0 - this.helpTextDis,
        textName5
      )
      this.arrHelpText.push(helpText5)
      // 左辅助线
      // let curDep = this.curveDirection === '0' ? -this.curveDepth : 0
      var textNameLeft = this.$commonJs.changeUnitDraw(
        mp.minP.z, this.graph.unit, false
      )
      var helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        mp.minP.z / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        mp.maxP.z - mp.minP.z, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        (mp.maxP.z + mp.minP.z) / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
      textNameLeft = this.$commonJs.changeUnitDraw(
        this.houseInfo.roomH - mp.maxP.z, this.graph.unit, false
      )
      helpTextLeft = this.$draw.toText(
        0 - this.helpTextDis - this.helpBesideDis,
        (this.houseInfo.roomH + mp.maxP.z) / 2 + lis,
        textNameLeft
      )
      this.arrHelpText.push(helpTextLeft)
    },

    onResize () {
      // TODO set conponent size
      this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px'
      this.child.resizeDraw()
    },

    testDigitalNegative (e, key) {
      e = e || '0'
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      let tempArray = e.split('.')
      this.vAngleDataSilder = e
      if (e && e !== '-' && ((tempArray.length > 1 && tempArray[1]) || tempArray.length === 1)) {
        this.vAngleDataSilder = (e * 1).toFixed(1) * 1
        this[key] = (e * 1).toFixed(1) * 1
      }
    },

    testDigitalNegativeBlur () {
      if (isNaN(this.vAngleDataSilder)) {
        let e = '0'
        this.vAngleDataSilder = (e * 1).toFixed(1) * 1
        this.vAngleData = (e * 1).toFixed(1) * 1
      }
    },
    moveCenter (value) {
      this.centerPosition.x = value.x
      this.centerPosition.y = value.y + this.$refs.sideView.$el.offsetTop
    }
  },

  watch: {
    vAngleData (newValue) {
      this.vAngleDataSilder = newValue
    }
  }
}
</script>

<style scoped>
.side-view {
  height: 100%;
  width: 100%;
  border-left: none;
  border-right: none;
  border-bottom: none;
  position: relative;
  overflow: hidden;
  border-right: 1px solid #bdbdbd;
  background: #fff;
}
.horizontal {
  font-size: 12px;
  float: right;
  margin: -15px 5px 0px 0px;
}
.inline {
  width: 300px;
  height: 44px;
  border: 1px solid #e3e3e3;
  margin-left: 50px;
  margin-top: -55px;
}
.side-img {
  background: url('../../assets/parts/icon/icon_side.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}

.side-view >>> .canvas_side {
  text-align: center;
  width: calc(100% - 55px);
  height: calc(100% - 60px);
  position: absolute;
  bottom: 0;
  left: 0;
}

.side-view-simpe {
  border: none;
}

.side-view-simpe >>> .canvas_side {
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.angle-msg {
  position: absolute;
  border: 1px solid;
  background-color: #f7baf7;
  padding: 3px;
  bottom: 1px;
  transform: translateX(-50%);
  left: 50%;
  width: fit-content;
}
.middle-btndis{
  background: #DCDFE6;
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  color: rgb(180, 180, 180);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  transform:rotate(0deg);
  padding: 0 10px;
}

.middle-btn {
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  background: rgb(0, 50, 152);
  color: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  transform:rotate(0deg);
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/sideView.vue